<template>
  <div class="exhibitionRecord">
    <el-col class="userinfoList infoPub" style="width: 990px">
      <div class="exhContent">
        <!-- 搜索组件   broadClass-->
<!--        <search-bar-->
<!--          :selectType="ExhIndexType"-->
<!--          :searchInputPlc="userInfo.user_nature == 1 ? searchInputPlc : searchInputPlc2"-->
<!--          :searchSelectPlc="searchSelectPlc"-->
<!--          @changeExhibitionState="getChangeData"-->
<!--          @toSearch="search"-->
<!--          :isExport="true"-->
<!--          :interview="interview"-->
<!--          :userInfoId="userInfo.user_id"-->
<!--          isExportFlag = "2"-->
<!--        />-->

        <div class="search-div">
          <el-form>
            <el-form-item>
              <el-select
                  clearable
                  style="width:184px;background:#fff;border: 1px solid #e6e6e6;margin-right:10px;border-radius: 5px; "
                  v-model="conferenceName"
                  placeholder="会议名称"
                  v-if="userInfo.user_nature == 1"
              >
                <el-option
                    v-for="(item,index) in exh_list"
                    :key="index"
                    :label="item.exh_name"
                    :value="index"
                ></el-option>
              </el-select>
              <el-select
                  clearable
                  style="width:184px;background:#fff;border: 1px solid #e6e6e6;margin-right:10px;border-radius: 5px; "
                  v-model="interState"
                  placeholder="面试状态"
                  v-if="userInfo.user_nature == 1"
              >
                <el-option
                    v-for="item in interviewState"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                ></el-option>
              </el-select>
              <el-input
                  placeholder="公司名称/直播间名称"
                  v-model="exhName"
                  class="input-with-select"
                  style="margin-right:10px;border-radius: 5px;width: 461px;"
              >
              </el-input>
              <el-button
                  class="searchBtn"
                  @click.native="search"
                  style="width: 100px;background-color: #0071ff;border-radius: 5px;border: none;"
              >
                <span style="color: #fff;font-size: 16px;">搜索</span>
              </el-button>
            </el-form-item>
          </el-form>
        </div>

        <!--提示信息-->
<!--        <div class="prompt-info-wrap tipsPrepare" v-if="userInfo.user_nature == 1">-->
<!--          <div-->
<!--              class="prompt-info"-->
<!--              v-if="lan == 'ch'"-->
<!--          >-->
<!--            1、观展前，请确保您使用的参展电脑配有摄像头，耳机和麦克风设备。-->
<!--          </div>-->
<!--          <div-->
<!--              class="prompt-info"-->
<!--              v-if="lan == 'ch'"-->
<!--          >-->
<!--            2、观展时，请使用谷歌浏览器打开展会官网，如需安装，<span-->
<!--              class="download"-->
<!--              @click="download"-->
<!--          >-->
<!--              {{ language.down }}-->
<!--            </span>-->
<!--          </div>-->
<!--        </div>-->


        <!-- table -->
        <pub-table class="intervie-table" :columns="userInfo.user_nature == 1 ?  columns : columnsCom" :tableData="exhibitionRecordData" :loading="loading" :ticketMan="ticketMan">

          <template v-slot:interview="dataList">
            <span v-if="dataList.row == '已面试'" style="color: #54d988;">{{dataList.row}}</span>
            <span v-else-if="dataList.row == '未面试'" style="color: #f48b26">{{dataList.row}}</span>
            <span v-else-if="dataList.row == '邀请未接'" style="color: #884e17">{{dataList.row}}</span>
            <span v-else-if="dataList.row == '被拒绝'" style="color: #dc2f2f;">{{dataList.row}}</span>
          </template>
          <!-- 插槽 {dataList.dataList:table操作数据}-->
          <template v-slot:action="dataList">
            <div slot="action">
              <!--broadcast_state == 2 exh_bstate != 4 broadcast_type==2  回放-->

               <el-button
                size="small"
                v-if="userInfo.user_nature == 3 && dataList.dataList.broadcast_type == 2 && dataList.dataList.exh_bstate != 4 && dataList.dataList.broadcast_state == 2"
                @click="handlePlayback(dataList.dataList)"
                style="background-color: #005bcd;border: none;width: 62px;height:30px;font-size: 16px;color: #FFFFFF;border-radius: 5px;"
              >{{language.playback}}</el-button>
              <!--进入  exh_bstate == 2  broadcast_state != 2-->
               <!-- <el-button
                type="primary"
                size="small"
                v-if="userInfo.user_nature == 3 && dataList.dataList.broadcast_type == 2 && dataList.dataList.exh_bstate == 2 && dataList.dataList.broadcast_state != 2"
                @click="handleJoin(dataList.dataList)"
                style="background-color: #f4a100;font-size: 14px;border: none"
              >{{language.enter}}</el-button> -->

              <!--我要洽谈
              <el-button
                @click="handleTakl(dataList.dataList.broadcast_id)"
                type="primary"
                size="small"
                v-if="dataList.dataList.exh_bstate == 2 && dataList.dataList.broadcast_state == 1"
                style="background-color: #f4a100;font-size: 14px;border: none"
              >{{language.talkBtn}}</el-button>-->

              <!--面试人员列表-->
              <el-button
                  size="small"
                  @click="handleInterviewee(dataList.dataList)"
                  v-if="userInfo.user_nature == 3"
                  style="background-color: #f47900;border: none;width: 124px;height:30px;font-size: 16px;color: #FFFFFF;border-radius: 5px;"
              >{{language.intervieweeList}}</el-button>

              <!--查看详情 个人-->
              <el-button
                  size="small"
                  v-if="userInfo.user_nature == 1"
                  @click="handlePlayback(dataList.dataList)"
                  style="background-color: #0071ff;border: none;height:30px;font-size: 16px;color: #FFFFFF;border-radius: 5px;margin-left: 8px;padding:6px 10px;"
              >查看详情</el-button>

            </div>
          </template>
        </pub-table>
        <!-- page -->
        <table-page
          :pageSize="pageSize"
          :layout="layout"
          :pageTotal="pageTotal"
          :currentPage="currentPage"
          @pageChange="getLimit"
        ></table-page>
      </div>
    </el-col>
    <drag-dialog
      :show.sync="dialogShow"
      :title="title"
      :language="language"
      :width="choose == 'playback' ? '602px' : '974px'"
      :fn="stateEnum.PLAYBACK"
      :initCont="initCont"
      :columns="choose == 'playback' ? columnGz : columnIn"
      :choose="choose"
      @select-cz-info="handleGzInfo"
      class="playback-tc"
    />

    <line-dialog :show.sync="visibleLine" :lan="language" :waitData="waitData" :lanState="lan" />
    <download-dialog :show.sync="downloadShow" />

    <!-- 企业详情 -->
    <company-dialog ref="companyDialog"></company-dialog>
  </div>
</template>
<script>
import lineDialog from "../../../components/LineDialog";
import { language } from "../../../language/get";
import Cookie from "../../../common/cookie";
import {exhibitionRecord, getBroadcastClass, getMyExhibition} from "../../../api/btManage";
import searchBar from "../components/searchbar/searchbar";
import pubTable from "../components/table/table";
import tablePage from "../components/tablepage/tablepage";
import { mapGetters } from "vuex";
import dragDialog from "../../../components/DragDialog/index";
import { isEmpty, isInternet } from "../../../common/validate";
import { stateEnum } from "../attendancerecord/enum";
import { callbackPlatVodio, getLiveUrl } from "../../../api/forum";
import { goRoom } from "../../../api/webSocket";
import { roomUrl, videoUrl, windowsGoTo } from "../../../common/url";
import downloadDialog from "../../../components/DownloadDialog/index";
import {MessageBox} from 'element-ui';
import { ExhIndexType } from "../../../common/constant/exhibition";
import companyDialog from "@/pages/forum/companyDialog";
const pubLanguage = language();
export default {
  components: {
    searchBar,
    companyDialog,
    pubTable,
    tablePage,
    dragDialog,
    lineDialog,
    downloadDialog,
  },
  data() {
    return {
      exh_list:[],
      interviewState:[
          {value:0,
           label:"全部"
        },
        {value:1,
          label:"已面试"
        },
        {value:2,
          label:"未面试"
        },
        {value:3,
          label:"邀请未接"
        },
        {value:4,
          label:"被拒绝"
        }],
      exhName:"",
      conferenceName:"",
      interState:"",
      choose:"playback",
      ExhIndexType,
      ticketMan:true,
      loading: true,
      dialogShow: false,
      language: pubLanguage,
      stateEnum,
      //page
      pageTotal: 0,
      pageSize: 6,
      currentPage: 1,
      downloadShow: false,
      layout: "prev, pager, next, jumper",
      //搜索相关
      broadClass: [],
      interview: true, //面试记录
      searchData: null,
      searchInputPlc: pubLanguage.studioFairName,
      searchInputPlc2: pubLanguage.studioFairName2,
      searchSelectPlc: pubLanguage.classification,
      //table 表头
      columns: [
        {
          title: pubLanguage.interState,
          key: "interview",
          width: "102"
        },
        {
          title: pubLanguage.indexSou1,
          key: "company",
          width: "162"
        },
        {
          title: pubLanguage.studioName,
          key: "broadcast_name",
          width: "162"
        },
        {
          title: pubLanguage.ticName,
          key: "exh_name",
          width: "162"
        },
        {
          title: pubLanguage.interviewTime,
          key: "truetime",
          width: "181"
        },
        {
          title: pubLanguage.interviewer,
          key: "truename",
          width: "81"
        },
        // {
        //   title: pubLanguage.email,
        //   key: "broadcast_contact",
        //   width: "182"
        // },
        {
          title: pubLanguage.operation,
          key: "action",
          width: "119"
        }
      ],
      columnsCom:[
        {title: pubLanguage.studioName,
          key: "broadcast_name",
          width: "249"
        },
        {title: pubLanguage.ticName,
          key: "broadcast_name",
          width: "289"
        },
        {title: pubLanguage.recruiter,
          key: "broadcast_er",
          width: "189"
        },
        {title: pubLanguage.operation,
          key: "action",
          width: "242"
        },],
      lan: Cookie.get("lang"),
      exhibitionRecordData: [],
      cloneData: [],
      fromData: {
        broadcast_class: "",
        keyword: "",
        interview_state:""
      },
      title: "",
      initCont: null,
      //回放
      columnGz: [
        {
          title: pubLanguage.date,
          key: "time",
          width: "420"
        },
        {
          title: pubLanguage.operation,
          key: "action"
          // width: ''
        }
      ],
      //面试人员列表
      columnIn:[
        {
          title:pubLanguage.name,
          key: "name",
          width: "156"
        },
        {
          title: pubLanguage.contact,
          key: "contact",
          width: "186"
        },
        {
          title:pubLanguage.intention,
          key: "job",
          width: "210"
        },
        {
          title: pubLanguage.remark,
          key: "remark",
          width: "176"
        },
        {
          title: pubLanguage.operation,
          key: "action",
          width: "206"
        }
      ],
      //排队
      visibleLine: false,
      waitData: {}
    };
  },
  created() {
      this.exhibitionRecordList();
      this.getExhname();
  },
  methods: {
    //下载谷歌浏览器
    download() {
      window.open(
          "https://www.google.cn/intl/zh-CN/chrome/?brand=CHBD&gclid=EAIaIQobChMI_JKx1J2Z6QIVjqmWCh2-qwpkEAAYASAAEgKlBvD_BwE&gclsrc=aw.ds"
      );
    },
    getExhname(){
      getMyExhibition({user_id: this.userInfo.user_id, lan: this.lan}).then((res) =>  {
        let exh_list = res.data;
        exh_list.unshift({
          exh_name: "全部",
          exh_name_en: "ALL",
          exh_state: "",
          exhibition_id: ""
        });
        this.exh_list = exh_list;
        // this.exhibition_id = "";
        // console.log("00000:" , this.exh_list);
      })
    },
    //回放
    handlePlayback(data) {
      console.log(data)
      this.$refs.companyDialog.showUpParticipants([{
        user_id: data.user_id,
        ExhibitionId: data.exhibition_id,
      },0],0);
      /*this.choose = "playback";
      this.title = `${this.language.playbackList} - ${data.broadcast_name}`;
      this.initCont = data;
      this.dialogShow = true;*/
    },
    //面试人员列表
    handleInterviewee(data) {
      this.choose = "interviewee";
      this.title = `${this.language.inviteList} - ${data.broadcast_name}`;
      this.initCont = data;
      this.dialogShow = true;
    },
    handleGzInfo(row, initCont, fn) {
      if (fn == this.stateEnum.PLAYBACK) {
        const props = {
          roomid: initCont.broadcast_id,
          broadcast_playback_id: row.broadcast_playback_id
        };
        window.open(videoUrl(props));
        // window.location.href = videoUrl(props);
        return;
      }
    },
    //进入直播间
    handleTakl(id) {
      if (!isInternet()) {
        return (this.downloadShow = true);
      }
      const props = {
        token: this.token,
        broadcast_id: id
      };

      this.$store
        .dispatch("getLiveInfo", props)
        .then(res => {
          if (res.type != "1") {
            if (isEmpty(res.data)) {
              if (this.lan == "ch") {
                return this.$message.error({ message: res.text, offset: 120 });
              } else {
                this.$message.error({ message: res.text_en, offset: 120 });
              }
              return;
            }
            const data = res.data[0];
            if (data.type != 1) {
              if (this.lan == "ch") {
                return this.$message.error({ message: res.text, offset: 120 });
              } else {
                return this.$message.error({
                  message: res.text_en,
                  offset: 120
                });
              }
              return;
            }
            const waitData = {
              token: this.token,
              roomid: data.roomid
            };
            //需要排队
            if (res.data[0].type == 1) {
              this.waitData = waitData;
              this.visibleLine = true;
            }
            return;
          }
          const data = res.data[0];
          let name = Cookie.get("lang") == 'ch' ? (this.userInfo.true_name || this.userInfo.true_name_en) : (this.userInfo.true_name_en || this.userInfo.true_name);
          return (window.location.href =
            windowsGoTo() + roomUrl(data, name));
          const goData = {
            token: this.token,
            roomid: data.roomid
          };
          // 不需要直接进入
          // goRoom(goData).then(res => {
          //   if (res.type == '1') {
          //
          //   }
          // })
        })
        .catch(() => {});
    },
    //进入论坛
    handleJoin(id) {
      if (!isInternet()) {
        return (this.downloadShow = true);
      }
      const props = {
        token: this.token,
        broadcast_id: id.broadcast_id
      };
      getLiveUrl(props).then(res => {
        if (res.type == 11){
          MessageBox({
            title: "",
            message: Cookie.get("lang")=='ch'?res.text:res.text_en,
            confirmButtonText: language().confirm,
            cancelButtonText: language().cancel,
            showCancelButton: false,
            // type: 'success'
          }).then(() => {
            //确认
          }).catch(() => {
            //取消
          });
        } else if (res.type != "1") {
          if (this.lan == "ch") {
            return this.$message.error({ message: res.text, offset: 120 });
          }
          return this.$message.error({ message: res.text_en, offset: 120 });
        }
        const data = res.data[0];
        sessionStorage.setItem('userType', res.prcurl);
        let name = Cookie.get("lang") == 'ch' ? (this.userInfo.true_name || this.userInfo.true_name_en) : (this.userInfo.true_name_en || this.userInfo.true_name);
        return (window.location.href =
          windowsGoTo() + roomUrl(data, name));
      });
    },
    getChangeData(state, val) {
      this.fromData.broadcast_class = state;
      this.fromData.keyword = val;
      this.exhibitionRecordList();
    },
    search() {
      if(this.conferenceName){
        this.fromData.conference_name = this.exh_list[this.conferenceName].exh_name;
      }else{
        this.fromData.conference_name = "";
      }
      // console.log("22===" + this.conferenceName);
      this.fromData.keyword2 = this.exhName;
      this.fromData.interview_state = this.interState;

      console.log("++++ " + this.fromData.interview_state);
      this.currentPage = 1;
      this.exhibitionRecordList();
    },
    getLimit(val) {
      this.currentPage = val;
      this.exhibitionRecordList();
    },
    //获取直播间分类
    broadcastClass() {
       const liveClass = localStorage.getItem("liveClass")
       if(!liveClass){
        getBroadcastClass({exhibition_id:""}).then(res => {
          if (res.type != "1") {
            if (this.lan == "ch") {
              return this.$message.error({ message: res.text, offset: 120 });
            }
            return this.$message.error({ message: res.text_en, offset: 120 });
          }
          const data = res.data;

          data.splice(0, 0, {
            broadcast_class_id: "",
            broadcast_class_name: "全部",
            broadcast_class_name_en: "All"
          });
          this.broadClass = data;
        });
       }else{
          this.liveClass = JSON.parse(liveClass);
       }
    },
    //展会门票列表
    exhibitionRecordList() {
      let that = this;
      this.loading = true;
      let data = {
        token: that.token,
        conference_name: that.fromData.conference_name,
        keyword2: that.fromData.keyword2,
        record_status:that.fromData.interview_state,
        lan: this.lan,
        currentPage: that.currentPage,
        numberPage: that.pageSize
      };
      exhibitionRecord(data).then(res => {
        if (res.type != "1") {
          if (this.lan == "ch") {
            return this.$message.error({ message: res.text, offset: 120 });
          }
          return this.$message.error({ message: res.text_en, offset: 120 });
        }
        let data = res.data;
        // console.log("面试记录==" , data);
        if (
          typeof data == undefined ||
          data == "" ||
          data == null ||
          isEmpty(data)
        ) {
          this.exhibitionRecordData = [];
          this.pageTotal = Number(res.datacount);
          return;
        }

         data.forEach(item => {
           // item.exh_time = `${item.exh_begtime} ${pubLanguage.to} ${item.exh_endtime}`;
           item.exh_name == (item.exh_name || item.exh_name_en)||'';
           item.exh_name_en == (item.exh_name_en || item.exh_name)||'';
           item.broadcast_name == (item.broadcast_name || item.broadcast_name_en)||'';
           item.broadcast_name_en == (item.broadcast_name_en || item.broadcast_name)||'';
           /*if (this.lan=="en") {
            item.exh_name = item.exh_name_en
            item.broadcast_name = item.broadcast_name_en
           }*/

         });


        this.exhibitionRecordData = data;
        console.log("---- " , this.exhibitionRecordData);

        // var aa = $('.el-tooltip').text();
        // alert(aa);
        // if($('.el-tooltip').text() == "已面试") {
        //   $('.el-tooltip').css('color', 'green');
        // }

        this.pageTotal = Number(res.datacount);
      });
      this.loading = false;
    }
  },
  computed: {
    ...mapGetters(["token", "userInfo"])
  }
};
</script>
<style scoped>
.el-button--small,
.el-button--small.is-round {
  padding: 6px 14px;
}
.intervie-table >>> tr td  .cell.el-tooltip {
  white-space: normal;
}

.playback-tc >>> .el-dialog__header {
  height: 60px;
  border-bottom: 1px solid #CCCCCC;
}
.playback-tc >>> .el-dialog__header span {
  font-size: 24px;
  color: #333333;
  position: relative;
  top: 30px;
  font-weight: 550;
}
.playback-tc >>> .el-icon-close {
  background: #2b6ff9;
  width: 20px;
  height: 20px;
}
.playback-tc >>> .el-table::before {
  background-color: #e5e5e5;
}
.exhibitionRecord >>> .tableNode {
  margin-top: 10px;
  padding-bottom: 40px;
}
.exhibitionRecord >>> .tipsPrepare {
  background: #fff;
  padding: 25px 0 28px 15px;
  border-radius: 5px;
  margin-top: 10px;
}
.exhibitionRecord >>> .tipsPrepare .prompt-info {
  height: 30px;
  line-height: 30px;
  background: #fff;
  padding-left: 0;
  color: #f47900;
  font-size: 18px;
  font-weight: bold;
}
.exhibitionRecord >>> .tipsPrepare.prompt-info span {
  color: #0071ff;
  cursor: pointer;
}
  .exhibitionRecord >>> .el-pagination .el-pager li{
    width: 30px;
    height: 30px;
    line-height: 30px;
    background:none;
    font-size: 14px;
  }
  .exhibitionRecord >>> .el-pagination .btn-next{
    border: 1px solid #CCCCCC;
    border-radius: 4px;
  }
  .exhibitionRecord >>> .el-pagination .btn-prev{
    border: 1px solid #CCCCCC;
    border-radius: 4px;
  }
  .exhibitionRecord >>> .el-pagination .el-input__inner{
    width: 30px;
    height: 30px;
    line-height: 25px;
    margin-top: -15px !important;
  }
  .exhibitionRecord >>> .el-pagination .el-pagination__jump{
    width: 25px;
    height: 25px;
    line-height: 25px;
  }
.search-div {
  background: #ffffff;
  height: 40px;
  padding: 10px;
}
.exhibitionRecord >>> .page{
  margin-left: 0;
}
.exhibitionRecord >>> .page .page-contfirm {
  margin-left: 50px;
}
</style>
